<template>
    <div class="eva-crm-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                  eva crm - a smarter way to run your business.
                </div>
                <div class="logo">
                    <img src="/images/powered-by-logo-eva-crm.png">
                </div>
            </div>
            <div class="box-1">
                <h1>A custom-built CRM (Customer Relationship Management) tool for window installers customisable to your precise needs</h1>
            </div>
            <div class="overlapping-image">
              <img src="/images/installer-benefits-landing-page-eva-crm-1.png">
            </div>
            <div class="box-2">
              <div class="box-2-cols">
                <div class="box-2-col">
                  <div class="box-2-col-header">
                    <img src="/images/installer-benefits-landing-page-eva-box-2-col-1.png">
                    <h2>Top of the lists</h2>
                  </div>
                  <p>
                    You know that your customers are the lifeblood of your business, so you want to provide them with the best possible experience.
                  </p>
                  <ul>
                    <li>
                      A happy customer will ask you back another day and will also recommend you to family and friends.
                    </li>
                    <li>
                      Your business may be complex to manage, but timing, accuracy and information sharing within your organisation and to your customer makes you more effective.
                    </li>
                  </ul>
                  <p>
                    With eva crm running the show, you’ll be putting your customers, your rankings and your business efficiency at the top of the lists.
                  </p>
                </div>
                <div class="box-2-col">
                  <div class="box-2-col-header">
                    <img src="/images/installer-benefits-landing-page-eva-box-2-col-2.png">
                    <h2>Partnerships</h2>
                  </div>
                  <p>
                    We have teamed up with eva crm, part of the Emplas group of companies, who have created a CRM for window installers that delivers in every area.
                  </p>
                  <ul>
                    <li>
                      Consolidation of your business processes and software into a single unified system.
                    </li>
                    <li>
                      Simplification of administration with a solution tailored to your organisation and precise needs.
                    </li>
                  </ul>
                  <p>
                    With the customisable eva crm platform you’ll be able to free up time to develop your business and build your customer base.
                  </p>
                </div>
                <div class="box-2-col">
                  <div class="box-2-col-header">
                    <img src="/images/installer-benefits-landing-page-eva-box-2-col-3.png">
                    <h2>25% DISCOUNT*</h2>
                  </div>
                  <p>
                    The eva crm team will be with you all the way throughout your installation, customising your platform, getting you up to speed, and providing ongoing technical support.
                  </p>
                  <ul>
                    <li>
                      There is a one-off installation fee that will be quoted according to the amount of resource and training needed to switch your business over to eva crm.
                    </li>
                    <li>
                      A monthly licence fee then covers your ongoing needs including maintenance, administration, technical support and security of your data.
                    </li>
                  </ul>
                  <p>
                    The eva crm team will only need a few days to oversee your installation and are currently offering a 25% discount* on licence fees for your first six months.
                  </p>
                  <p class="txt-sm">
                    *Exclusively for Epwin Connect members. Excludes installation fee.
                  </p>
                </div>
              </div>
              <p class="align-center">
                <a class="btn-primary _lg" @click="enquiry_box_open = true">
                  <strong>Get in touch</strong>
                </a>
              </p>
            </div>
          <div class="box-3">
            <div class="content">
              <h1>The eva crm app</h1>
              <p>
                <strong>Invaluable tool for customer-facing team members.</strong>
              </p>
              <p>
                It places the key data in the palm of their hand when on site with customers, during installations or at any time away from your headquarters.
              </p>
            </div>
            <div class="images">
              <img src="/images/installer-benefits-landing-page-eva-box-3.png">
            </div>
          </div>
          <div class="box-4">
            <div class="box-4-cols">
              <div class="box-4-col">
                <div class="box-4-col-header">
                  <img src="/images/installer-benefits-landing-page-eva-box-4-col-1.png">
                  <h2>Lead management</h2>
                </div>
                <p>
                  You get a comprehensive and secure lead management suite which is fully integrated into your business reporting.
                </p>
                <ul>
                  <li>
                    Whether you capture your leads through your own website or through a third-party lead generator, you’ll never lose a lead with eva crm.
                  </li>
                  <li>
                    You’ll know exactly what is happening with every lead generated, from the first interaction through to conversion.
                  </li>
                </ul>
                <p>
                  The comprehensive lead capture and consolidated lead reporting package helps you to refine your strategies and improve your conversion rates.
                </p>
              </div>
              <div class="box-4-col">
                <div class="box-4-col-header">
                  <img src="/images/installer-benefits-landing-page-eva-box-4-col-2.png">
                  <h2>Scheduling</h2>
                </div>
                <p>
                  Precision scheduling ensures prompt and efficient customer service, and, just as importantly, helps your sales and installation teams to be more effective.
                </p>
                <p>
                  Scheduling features include:
                </p>
                <ul>
                  <li>Bespoke schedule view built to your requirements.</li>
                  <li>Search function.</li>
                  <li>Internal team management option.</li>
                  <li>Expanded slot view.</li>
                </ul>
                <p>
                  Simple administration and complete visibility of scheduling and appointments to your core team members.
                </p>
              </div>
              <div class="box-4-col">
                <div class="box-4-col-header">
                  <img src="/images/installer-benefits-landing-page-eva-box-4-col-3.png">
                  <h2>Personalised & Secure</h2>
                </div>
                <p>
                  Because everything with eva crm is built to your precise requirements, you get a familiar and secure working environment throughout your organisation.
                </p>
                <ul>
                  <li>
                    Workflows and checklists will be updated to reflect your own business terminologies, meaning your teams are operating in very familiar territory from the get-go.
                  </li>
                  <li>
                    You can access a full suite of standard business reports that you can tailor to your operations.
                  </li>
                </ul>
                <p>
                  You can create tiered access to your individual team members, with access levels granted according to their specific information needs.
                </p>
              </div>
            </div>
            <p class="align-center">
              <a class="btn-primary _lg" @click="enquiry_box_open = true">
                <strong>Contact eva crm</strong>
              </a>
            </p>
          </div>
        </div>
      <div class="box-6">
        <h1>Security</h1>
        <div class="box-6-cols">
          <div class="box-6-col-1">
            <img src="/images/installer-benefits-landing-page-eva-box-6-1.png">
            <p>
              <strong>Comprehensive customer data</strong>
            </p>
            <p>
              Every detail of your customer including files, photos, emails and notes is stored securely and easily indexed by your trusted team members.  You can manage access levels with complete control, confidence and compliance.
            </p>
          </div>
          <div class="box-6-col-2">
            <img src="/images/installer-benefits-landing-page-eva-box-6-2.png">
            <p>
              <strong>Security and support</strong>
            </p>
            <p>
              With multi-factor authentication your data is safe and secure.  For extra peace of mind, your data is backed up hourly, and you have a dedicated eva crm support desk if you get into any bother.
            </p>
          </div>
        </div>
        <p class="align-center">
          <a class="btn-primary-outline _lg" @click="enquiry_box_open = true">
            <strong>Contact the eva crm team</strong>
          </a>
        </p>
      </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">eva crm Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
    props: [
        'logged_in_user',
    ],
    components: {
      vueVimeoPlayer
    },
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like more information about eva crm',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 58,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': ' enquiry',
                'value': 'eva crm enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - eva crm`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'eva crm partner link clicked',
          'value': 'eva crm partner link clicked',
        });
      },
    },
};
</script>
